import merge from 'lodash-es/merge';
import getDefaultStyle from '../css/defaultStyle';
import updateStyle from '../css/updateStyle';
import lookAndFeel from '../lookAndFeel';
import updateStyleByRef from '../css/updateStyleByRef';
import frameProps from '../css/frameProps';
import { updateClasses, getDefaultControl } from './audio.defaults';
import Control from './control';
import uniqueId from '../uniqueId';
import AudioAPI from '../../audioApi';

const defaultFrame = {
  position: 'absolute',
  display: 'block',
  overflow: 'hidden',
  top: '8px',
  left: '8px',
  width: 'auto',
  height: 'auto',
}

export default class Audio extends Control {

  constructor(instance, path, nicePath) {
    super(instance, path, nicePath);
    this._defaultShow = false;
    
    this.addApi(this, 'url', () => {    
      return this._checkDataOption(
        'url',
        this._controlOptions.url,
      );
    });
  }
  
  renderElement() {
    const control = this;
    const options = this._controlOptions;
    if(options.visible===undefined){
      options.visible = true;
    }

    if (!control.el) {
      control.el = getDefaultControl(control);
      if(!control.id){
        control.id = uniqueId(control.el, 'recharts-audio-',Audio);
        control.styleSheet = 'css-' + control.id;        
      }else{
        control.el.setAttribute('id',control.id);
      }

      control.audio = new AudioAPI(control, 'options', control.el.getElementsByClassName('body')[0]);
    }

    updateClasses(control,options);
    
    // var body = control.el.getElementsByClassName('body')[0];
    var placeholder = control.el.getElementsByClassName('body-placeholder')[0];
    
    control.audio.setControls(control.visible);
    if(!control.visible && (control.isLayoutMode||control.isDesignMode)){
      placeholder.style.display = 'block';      
    }else{
      placeholder.style.display = 'none';
    }


    

    var frameStylePatch = _.pick(merge({},getDefaultStyle(),defaultFrame, options.style.normal, {width:'auto'},{height: 'auto'}), frameProps);

    let scheme = lookAndFeel(options.lookAndFeel, options.style.normal.height);

    updateStyleByRef(frameStylePatch, scheme);
    updateStyle(control.el, frameStylePatch, control.currentFrameStyle);

    control.currentFrameStyle = frameStylePatch;

    //bodyEl.innerHTML = control.text === undefined || control.text === null? '':control.text;
    
    // if(control._prevUrl !==control.url){
    //   bodyEl.setAttribute('src', control.url);      
    //   control._prevUrl = control.url;
    // }
    control.audio.setUrl(control.url);

    return control.el;
  }

  dropBoxGetFileUrl({path,name}){
    return this.instance.dropBoxGetFileUrl({path,name});
  }
}
